import {
    GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS,
    GET_REGULATIONS_AND_RATES_FOR_SCENARIO,
    GetAllProposedRegulationsByIdAction,
    GetAllRestrictionsForGivenRegulationIdsAction,
    GetRegulationsAndRatesForScenarioAction,
    RegulationsAndRatesForScenarioReceivedAction,
    UPDATE_ZONE_ACTION,
    updateZoneAction
} from "./../../actions/regulation/types";
import axios from "axios";
import { SelectEffect, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { showError, showPopUp } from "../../components/commonUtilities";
import {
    CHECK_LINK_HAS_PROPOSED_REGULATION,
    CHECK_REGULATION_HAS_PROPOSED_REGULATION,
    COPY_REGULATION_TO_PROPOSED,
    DELETE_PROPOSED_REGULATION,
    DELETE_PROPOSED_RESTRICTION,
    GET_PROPOSED_REGULATION_LINKS,
    GET_PROPOSED_REGULATION,
    GET_PROPOSED_RESTRICTION,
    GET_REGULATION_LINKS,
    GET_REGULATION_SECTION,
    POST_PROPOSED_RESTRICTION,
    UPDATE_PROPOSED_REGUATION,
    UPDATE_PROPOSED_RESTRICTION,
    CheckLinkHasProposedRegulation,
    CheckRegulationHasProposedRegulation,
    CopyRegulationToProposedAction,
    DeleteProposedRegulationAction,
    DeleteProposedRestrictionAction,
    GetProposedRegulationLinksAction,
    GetProposedRestrictionAction,
    GetRegulationLinksAction,
    GetRegulationSectionAction,
    PostProposedRestrictionAction,
    UpdateProposedRegulationAction,
    UpdateProposedRestrictionAction,
    GetProposedRegulationAction,
    GetAllRestrictionsAction,
    RegulationSectionReceivedAction,
    AllRestrictionsReceivedAction,
    RegulationToProposedPostedAction,
    ProposedRegulationReceivedAction,
    LinkHasProposedRegulationExtraParams,
    RegulationLinksReceivedAction,
    ProposedRestrictionDeletedAction,
    ProposedRestrictionUpdatedAction,
    ProposedRestrictionReceivedAction,
    ProposedRegulationDeletedAction,
    AllProposedRegulationReceivedAction,
    GET_ALL_PROPOSED_REGULATIONS_BY_ID
} from "../../actions/regulation/types";
import {
    createdProposedRegulationReceived,
    setSegmentsToBeCreated
} from "../../actions/regulation/CreateRegulation";
import {
    allCurbLinksOfSameRegulationIdReceived,
    allProposedCurbLinksOfSameRegulationIdReceived
} from "../../actions/regulation/EditRegulation";
import {
    allProposedRegulationReceived,
    allRestrictionsReceived,
    proposedRegulationDeleted,
    proposedRegulationReceived,
    proposedRegulationUpdated,
    proposedRestrictionDeleted,
    proposedRestrictionReceived,
    proposedRestrictionUpdated,
    regulationLinksReceived,
    regulationsAndRatesForScenarioReceived,
    regulationSectionReceived,
    regulationToPropsedPosted
} from "../../actions/regulation";
import { getSubRestrictions } from "../../actions/Filters";
import { toggleProposedChanges } from "../../actions/regulation/proposedLinks";
import { toggleEditRegulationPanel } from "../../actions/regulation";
import {
    CREATE_PROPOSED_REGULATION,
    CreateProposedRegulationAction,
    CreateProposedRegulationLinksAction,
    POST_PROPOSED_REGULATION_LINKS
} from "../../actions/regulation/CreateRegulation/types";
import { getRegulationLinksType } from "../../constants";
import i18next from "i18next";
import { RootState } from "reducers";
import { LinkFeature } from "../../interfaces/Geoserver";
import { GeneratorYieldType } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
import {
    AllCurbLinksOfSameRegulationIdReceived,
    AllProposedCurbLinksOfSameRegulationIdReceived
} from "../../actions/regulation/EditRegulation/types";
import { GetSubRestrictions } from "../../actions/Filters/types";
import { ToggleProposedChangesAction } from "../../actions/regulation/proposedLinks/types";
import { GetAllProposedRegulationsAction } from "actions/regulation/Listview/types";
const selectedScenario = (state: RootState) => state.Scenarios.selectedScenario;
const isGeoserverEnabled = (state: RootState) => state.globals.isGeoserverEnabled;
const isBatchSelectionEnabled = (state: RootState) => state.batchSelection.isBatchSelectionEnabled;
const allProposedRegulationsReceived = (state: RootState) =>
    state.regulation.allProposedRegulationReceived;
const isEditParkingRatesInProgress = (state: RootState) =>
    state.editParkingRates.isEditParkingRatesInProgress;

function* getRegulationSection(
    action: GetRegulationSectionAction
): Generator<
    | Promise<RegulationSectionReceivedAction>
    | GeneratorYieldType<RegulationSectionReceivedAction["payload"]>,
    void,
    RegulationSectionReceivedAction["payload"]["regulationSection"]
> {
    try {
        if ("params" in action.payload) {
            const json = yield axios
                .get(`/api/regulation/${action.payload.id}/`, { params: action.payload.params })
                .then((response) => response.data);

            yield put(regulationSectionReceived({ regulationSection: json }));
        }
    } catch (error) {
        showError(error);
    }
}

export function* getRegulationSectionSaga() {
    yield takeLatest(GET_REGULATION_SECTION, getRegulationSection);
}

function* getRegulationsAndRatesForScenario(
    action: GetRegulationsAndRatesForScenarioAction
): Generator<
    | Promise<RegulationsAndRatesForScenarioReceivedAction>
    | SelectEffect
    | GeneratorYieldType<RegulationsAndRatesForScenarioReceivedAction["payload"]>,
    void,
    RegulationsAndRatesForScenarioReceivedAction["payload"]["regulationsAndRates"]
> {
    try {
        const json = yield axios
            .post(
                "/api/regulation/get_existing_and_proposed_payments_on_regulations/",
                action.payload.params
            )
            .then((response) => {
                return response.data;
            });
        yield put(regulationsAndRatesForScenarioReceived({ regulationsAndRates: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getAllRestrictionsSaga() {
    yield takeLatest(GET_REGULATIONS_AND_RATES_FOR_SCENARIO, getRegulationsAndRatesForScenario);
}

function* getAllRestrictionsForGivenRegulationIds(
    action: GetAllRestrictionsForGivenRegulationIdsAction
): Generator<
    | Promise<AllRestrictionsReceivedAction>
    | GeneratorYieldType<AllRestrictionsReceivedAction["payload"]>,
    void,
    AllRestrictionsReceivedAction["payload"]["allRestrictions"]["results"]
> {
    try {
        const json = yield axios
            .post("/api/allrestrictions/multiple_restrictions/", action.payload.bodyParams, {
                params: action.payload.queryParams
            })
            .then((response) => response.data);

        yield put(
            allRestrictionsReceived({
                allRestrictions: {
                    meta: {
                        count: json.length,
                        next: null,
                        previous: null
                    },
                    results: json
                }
            })
        );
    } catch (error) {
        showError(error);
    }
}

export function* getAllRestrictionsForGivenRegulationIdsSaga() {
    yield takeLatest(
        GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS,
        getAllRestrictionsForGivenRegulationIds
    );
}

function* copyRegulationToProposed(
    action: CopyRegulationToProposedAction
): Generator<
    | Promise<RegulationToProposedPostedAction>
    | GeneratorYieldType<RegulationToProposedPostedAction["payload"]>,
    void,
    RegulationToProposedPostedAction["payload"]["regulationToProposedPosted"]
> {
    try {
        if ("regulationId" in action.payload) {
            const json = yield axios
                .post(
                    `/api/regulation/${action.payload.regulationId}/copy_regulation_to_proposed/`,
                    action.payload
                )
                .then((response) => response.data);

            yield put(regulationToPropsedPosted({ regulationToProposedPosted: json }));
        }
    } catch (error: any) {
        if (error.response.status === 400) {
            yield put(regulationToPropsedPosted({ regulationToProposedPosted: error }));
        }
        showError(error);
    }
}

export function* copyRegulationToProposedSaga() {
    yield takeLatest(COPY_REGULATION_TO_PROPOSED, copyRegulationToProposed);
}

// Proposed Regulation
function* getProposedRegulation(
    action: GetProposedRegulationAction
): Generator<
    | Promise<ProposedRegulationReceivedAction>
    | GeneratorYieldType<ProposedRegulationReceivedAction["payload"]>,
    void,
    ProposedRegulationReceivedAction["payload"]
> {
    try {
        if ("regulationId" in action.payload && "params" in action.payload) {
            const json = yield axios
                .get(`/api/proposed_regulation/${action.payload.regulationId}/`, {
                    params: action.payload.params
                })
                .then((response) => response.data);

            yield put(proposedRegulationReceived({ proposedRegulationReceived: json }));
        }
    } catch (error) {
        showError(error);
    }
}

export function* getProposedRegulationSaga() {
    yield takeLatest(GET_PROPOSED_REGULATION, getProposedRegulation);
}

function* getProposedPayment(payment: any): any {
    const errors = {} as any;
    const json = yield axios
        .post("api/proposed_payment/", payment)
        .then((response) => response.data)
        .catch((error) => {
            errors["Proposed Payment"] = error;
        });
    return json;
}

function* updateProposedRegulation(
    action: UpdateProposedRegulationAction
): Generator<any, void, any> {
    const errors = {} as any;
    try {
        let paymentId = null;
        if (
            action.payload.proposedRegulationBody &&
            action.payload.proposedRegulationBody.payment &&
            action.payload.proposedRegulationBody.payment.fees?.length &&
            action.payload.proposedRegulationBody.payment.duration?.length
        ) {
            action.payload.proposedRegulationBody.payment_status = true;
            if (action.payload.proposedRegulationBody.payment.id !== undefined) {
                yield axios
                    .patch(
                        `api/proposed_payment/${action.payload.proposedRegulationBody.payment.id}/`,
                        action.payload.proposedRegulationBody.payment
                    )
                    .then((response) => response.data)
                    .catch((error) => {
                        errors["Proposed Payment"] = error;
                    });
            } else {
                const json = yield getProposedPayment(
                    action.payload.proposedRegulationBody.payment
                );
                paymentId = json.id;
            }
        } else {
            const json = yield getProposedPayment(action.payload.proposedRegulationBody.payment);
            paymentId = json.id;
        }
        if (action.payload.proposedRegulationBody.action === "Deletion") {
            delete action.payload.proposedRegulationBody.payment;
        }
        if (paymentId) {
            action.payload.proposedRegulationBody.payment_id = paymentId;
        }

        const json = yield axios
            .patch(
                `/api/proposed_regulation/${action.payload.id}/`,
                action.payload.proposedRegulationBody
            )
            .then((response) => {
                if (action.payload.nextProcess) {
                    action.payload.nextProcess();
                }
                return response.data;
            })
            .catch((error) => {
                errors["Proposed Regulation"] = error;
            });

        yield put(
            proposedRegulationUpdated({ id: action.payload.id, proposedRegulationUpdated: json })
        );

        // turn on proposed changes after submit
        if (!action.payload.isRedirectedFromEditPanel) {
            yield put(toggleProposedChanges({ toggle: true }));
            yield put(
                toggleEditRegulationPanel({ isEditRegulationPanelOpen: false, regulationId: -1 })
            );
        }

        if (action.payload.updateRestrictionsData) {
            yield Promise.all(
                Object.entries(action.payload.updateRestrictionsData).map((updateRestrictionData) =>
                    axios
                        .patch(
                            `/api/proposed_restriction/${updateRestrictionData[0]}/`,
                            updateRestrictionData[1]
                        )
                        .then((response) => response.data)
                        .then((response) =>
                            proposedRestrictionUpdated({
                                id: Number(updateRestrictionData[0]),
                                proposedRestrictionUpdated: response
                            })
                        )
                        .catch((error) => {
                            errors["Proposed Restriction"] = error;
                        })
                )
            );
        }
    } catch (error) {
        showError(error);
    }
}

export function* updateProposedRegulationSaga() {
    yield takeLatest(UPDATE_PROPOSED_REGUATION, updateProposedRegulation);
}

function* createProposedRegulation(
    action: CreateProposedRegulationAction
): Generator<any, void, any> {
    try {
        let paymentID = null;
        if (
            action.payload.proposedRegulationBody.payment.fees.length &&
            action.payload.proposedRegulationBody.payment.duration.length &&
            action.payload.proposedRegulationBody.payment.fees[0] !== "" &&
            action.payload.proposedRegulationBody.payment.duration[0] !== ""
        ) {
            action.payload.proposedRegulationBody.payment_status = true;
            const json = yield axios
                .post("api/proposed_payment/", action.payload.proposedRegulationBody.payment)
                .then((response) => response.data);
            paymentID = json.id;
        }
        if (paymentID) {
            action.payload.proposedRegulationBody.payment_id = paymentID;
        }
        const json = yield axios
            .post("/api/proposed_regulation/", action.payload.proposedRegulationBody)
            .then((response) => response.data);

        action.payload.afterSave(json.id);

        yield put(createdProposedRegulationReceived({ data: json }));
    } catch (error) {
        showError(error);
    }
}

export function* createProposedRegulationSaga() {
    yield takeLatest(CREATE_PROPOSED_REGULATION, createProposedRegulation);
}

function* deleteProposedRegulation(
    action: DeleteProposedRegulationAction
): Generator<
    | Promise<ProposedRegulationDeletedAction>
    | GeneratorYieldType<ProposedRegulationDeletedAction["payload"]>,
    void,
    ProposedRegulationDeletedAction["payload"]["proposedRegulationDeleted"]
> {
    try {
        const json = yield axios
            .delete(`/api/proposed_regulation/${action.payload.id}/delete_proposed_regulation/`)
            .then((response) => response.data);
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(
            proposedRegulationDeleted({ id: action.payload.id, proposedRegulationDeleted: json })
        );
    } catch (error) {
        showError(error);
    }
}

export function* deleteProposedRegulationSaga() {
    yield takeLatest(DELETE_PROPOSED_REGULATION, deleteProposedRegulation);
}

// Proposed Restriction

function* getProposedRestriction(
    action: GetProposedRestrictionAction
): Generator<
    | Promise<ProposedRestrictionReceivedAction>
    | GeneratorYieldType<ProposedRestrictionReceivedAction["payload"]>,
    void,
    ProposedRestrictionReceivedAction["payload"]["proposedRestrictionReceived"]
> {
    try {
        const json = yield axios
            .get("/api/proposed_restriction/", { params: action.payload.params })
            .then((response) => response.data);

        yield put(proposedRestrictionReceived({ proposedRestrictionReceived: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getProposedRestrictionSaga() {
    yield takeLatest(GET_PROPOSED_RESTRICTION, getProposedRestriction);
}

function* updateProposedRestriction(
    action: UpdateProposedRestrictionAction
): Generator<
    | Promise<ProposedRestrictionUpdatedAction>
    | GeneratorYieldType<ProposedRestrictionUpdatedAction["payload"]>,
    void,
    ProposedRestrictionUpdatedAction["payload"]
> {
    try {
        const json = yield axios
            .patch(
                `/api/proposed_restriction/${action.payload.id}/`,
                action.payload.proposedRestrictionBody
            )
            .then((response) => response.data);

        yield put(
            proposedRestrictionUpdated({ id: action.payload.id, proposedRestrictionUpdated: json })
        );
    } catch (error) {
        showError(error);
    }
}

export function* updateProposedRestrictionSaga() {
    yield takeEvery(UPDATE_PROPOSED_RESTRICTION, updateProposedRestriction);
}

function* deleteProposedRestriction(
    action: DeleteProposedRestrictionAction
): Generator<
    | Promise<ProposedRestrictionDeletedAction["payload"]>
    | GeneratorYieldType<ProposedRestrictionDeletedAction["payload"]>,
    void,
    ProposedRestrictionDeletedAction["payload"]["proposedRestrictionDeleted"]
> {
    try {
        const json = yield axios
            .delete(`/api/proposed_restriction/${action.payload.id}/`)
            .then((response) => response.data);

        yield put(
            proposedRestrictionDeleted({ id: action.payload.id, proposedRestrictionDeleted: json })
        );
    } catch (error) {
        showError(error);
    }
}

export function* deleteProposedRestrictionSaga() {
    yield takeEvery(DELETE_PROPOSED_RESTRICTION, deleteProposedRestriction);
}

function* postProposedRestriction(
    action: PostProposedRestrictionAction
): Generator<
    | Promise<GetSubRestrictions>
    | GeneratorYieldType<GetSubRestrictions["payload"]>
    | Promise<ToggleProposedChangesAction["payload"]>
    | GeneratorYieldType<ToggleProposedChangesAction["payload"]>,
    void,
    GetSubRestrictions["payload"]["params"]
> {
    try {
        const json = yield axios
            .post("/api/proposed_restriction/", action.payload.payload)
            .then((response) => response.data);
        if (json) {
            if (action.payload.isLastRestriction) {
                yield put(
                    getSubRestrictions({
                        params: {
                            fields: "id,name,display_name,filter_section,color,dash_style,activity__id,activity__name,in_manager,in_viewer,editable_parking_price,editable_max_stay,editable_parking_spaces,priority,display_priority"
                        }
                    })
                );
                yield put(toggleProposedChanges({ toggle: true }));
            }
        }
    } catch (error) {
        showError(error);
    }
}

export function* postProposedRestrictionSaga() {
    yield takeEvery(POST_PROPOSED_RESTRICTION, postProposedRestriction);
}

function* getRegulationLinks(
    action: GetRegulationLinksAction
): Generator<
    | Promise<AllCurbLinksOfSameRegulationIdReceived>
    | GeneratorYieldType<AllCurbLinksOfSameRegulationIdReceived["payload"]>
    | Promise<RegulationLinksReceivedAction>
    | GeneratorYieldType<RegulationLinksReceivedAction["payload"]>,
    void,
    | AllCurbLinksOfSameRegulationIdReceived["payload"]["curbLinks"]
    | RegulationLinksReceivedAction["payload"]["regulationLinksReceived"]
> {
    try {
        const json = yield axios
            .get("/api/regulationlinks/", { params: action.payload.params })
            .then((response) => response.data);

        if (
            action.payload.actionType === getRegulationLinksType.getAllCurbLinksWithSameRegulationID
        ) {
            yield put(allCurbLinksOfSameRegulationIdReceived({ curbLinks: json }));
        } else {
            yield put(regulationLinksReceived({ regulationLinksReceived: json }));
        }
    } catch (error) {
        showError(error);
    }
}

export function* getRegulationLinksSaga() {
    yield takeEvery(GET_REGULATION_LINKS, getRegulationLinks);
}

function* getProposedRegulationLinks(
    action: GetProposedRegulationLinksAction
): Generator<
    | Promise<AllProposedCurbLinksOfSameRegulationIdReceived["payload"]>
    | GeneratorYieldType<AllProposedCurbLinksOfSameRegulationIdReceived["payload"]>,
    void,
    | AllProposedCurbLinksOfSameRegulationIdReceived["payload"]["curbLinks"]
    | LinkHasProposedRegulationExtraParams
> {
    try {
        const json = yield axios
            .get("/api/proposedregulationlinks/", { params: action.payload.params })
            .then((response) => response.data);

        if (
            action.payload.actionType === getRegulationLinksType.getAllCurbLinksWithSameRegulationID
        ) {
            yield put(
                allProposedCurbLinksOfSameRegulationIdReceived({
                    curbLinks:
                        json as AllProposedCurbLinksOfSameRegulationIdReceived["payload"]["curbLinks"]
                })
            );
            action.payload.updateLinkFunc &&
                action.payload.segmentObject &&
                action.payload.updateLinkFunc(
                    action.payload.segmentObject,
                    json as LinkHasProposedRegulationExtraParams
                );
        }
    } catch (error) {
        showError(error);
    }
}

export function* getProposedRegulationLinksSaga() {
    yield takeEvery(GET_PROPOSED_REGULATION_LINKS, getProposedRegulationLinks);
}

function* createProposedRegulationLinks(action: CreateProposedRegulationLinksAction) {
    try {
        yield axios
            .post("api/proposedregulationlinks/", action.payload.regulationLinksBody)
            .then((response) => response.data);
    } catch (error) {
        showError(error);
    }
}

function* updateZone(action: updateZoneAction): Generator<any, void, any> {
    try {
        const json = yield axios.patch(
            `api/alllinks/${action.payload.zoneId}/`,
            action.payload.zoneBody
        );
        if (action.payload.nextProcess && json) {
            action.payload.nextProcess(json.data);
        }
    } catch (error) {
        showError(error);
    }
}

export function* updateZoneSaga() {
    yield takeLatest(UPDATE_ZONE_ACTION, updateZone);
}

export function* createProposedRegulationLinksSaga() {
    yield takeEvery(POST_PROPOSED_REGULATION_LINKS, createProposedRegulationLinks);
}

function* checkLinkHasProposedRegulation(
    action: CheckLinkHasProposedRegulation
): Generator<any, void, any> {
    try {
        let url = `/api/proposedregulationlinks/?curb_link__id=${action.payload.segmentObject.object.id}&fields=id`;

        // If custom group is enabled check custom link parent id
        if (action.payload.extraParams) {
            url = `/api/proposedregulationlinks/validate_existing_proposed_regulation/?parent_link=${action.payload.segmentObject.object.id}&is_custom_segment=${action.payload.extraParams.isCustomGroup}`;
        }
        const json = yield axios.get(url).then((response) => response.data);

        if (json.allow) {
            action.payload.updateLinkFunc &&
                action.payload.updateLinkFunc(
                    action.payload.segmentObject,
                    action.payload.extraParams
                );
        } else {
            showPopUp(
                `${i18next.t(
                    "The selected Link has a proposed custom segment. Delete, Edit or Publish this change from List View"
                )}.`,
                i18next.t("Proposed change already exists")
            );
        }
    } catch (error) {
        showError(error);
    }
}

export function* checkLinkHasProposedRegulationSaga() {
    yield takeEvery(CHECK_LINK_HAS_PROPOSED_REGULATION, checkLinkHasProposedRegulation);
}

function* checkRegulationHasProposedRegulation(
    action: CheckRegulationHasProposedRegulation
): Generator<
    | Promise<any>
    | SelectEffect
    | GeneratorYieldType<AllProposedRegulationReceivedAction["payload"]>
    | GeneratorYieldType<GetAllProposedRegulationsAction["payload"]>,
    void,
    any
> {
    try {
        const scenarioId = yield select(selectedScenario);
        const geoserverEnabled = yield select(isGeoserverEnabled);
        const isBatchSelection = yield select(isBatchSelectionEnabled);
        const objectId = geoserverEnabled
            ? (action.payload.segmentObject.object as unknown as LinkFeature).properties
                  .regulation_id
            : action.payload.segmentObject.object.regulation_id;

        let url =
            "/api/proposed_regulation/?actual_regulation__id=" +
            objectId +
            "&scenario__id=" +
            scenarioId.id +
            "&is_published=false&fields=id,is_published";
        const json = yield axios.get(url).then((response) => response.data);
        if (json.results.length === 0) {
            action.payload.updateLinkFunc &&
                action.payload.updateLinkFunc(action.payload.segmentObject);
        } else {
            showPopUp(
                i18next.t(
                    "The regulation on this segment already has a change proposed to it. Delete, edit, or publish this change from List View."
                ),
                i18next.t("Change Already Proposed")
            );
            if (!isBatchSelection) {
                action.payload.updateLinkFunc &&
                    action.payload.updateLinkFunc(action.payload.segmentObject);
            }
        }
    } catch (error) {
        showError(error);
    }
}

export function* checkRegulationHasProposedRegulationSaga() {
    yield takeEvery(CHECK_REGULATION_HAS_PROPOSED_REGULATION, checkRegulationHasProposedRegulation);
}

function* fetchAllProposedChangesById(
    action: GetAllProposedRegulationsByIdAction
): Generator<
    | Promise<any>
    | SelectEffect
    | GeneratorYieldType<AllProposedRegulationReceivedAction["payload"]>,
    void,
    any
> {
    try {
        const scenario = yield select(selectedScenario);
        const { params, offset: actionOffset, type: actionType } = action.payload;
        const { highlightedLinkIds = [], regIds = [], selectedFees = [] } = params;
        const type = actionType || "all";
        const offset = actionOffset ?? 0;
        const payload: { link_ids: number[] } = { link_ids: [] };

        const requestOrigin = action.payload.requestOrigin;

        if (highlightedLinkIds.length > 0) {
            payload.link_ids = highlightedLinkIds;
        }

        const makeUrl = (baseUrl: string, params: any) => {
            const query = Object.entries(params)
                .filter(
                    ([_, value]) =>
                        value !== undefined &&
                        ((Array.isArray(value) && value.length > 0) ||
                            (!Array.isArray(value) && value !== ""))
                )
                .map(([key, value]) =>
                    Array.isArray(value) ? `${key}=${value.join(",")}` : `${key}=${value}`
                )
                .join("&");
            return `${baseUrl}?${query}`;
        };

        const getProposedRegulation = async () => {
            const params = {
                limit: 10,
                offset: offset * 10,
                ordering: "-id",
                is_published: false,
                scenario__id: scenario.id,
                fields: "id,action,is_published,payment,proposed_restrictions,regulationId,actual_regulation_id,effective_dates_period,proposedregulationlinks_set__curb_link__bl_street_name,proposedregulationlinks_set__curb_link__id,sub_activity__display_name,sub_activity__id,proposedregulationlinks_set__custom_link__bl_street_name,proposedregulationlinks_set__id,proposedregulationlinks_set__custom_link__id,sub_activity__activity__name,description",
                ...(regIds.length ? { sub_activity__id__in: regIds } : {}),
                ...(selectedFees.length ? { fees__in: selectedFees } : {})
            };
            const url = makeUrl("/api/proposed_regulation/fetch_proposed/", params);
            return await axios.post(url, payload).then((response) => response.data);
        };

        const getProposedCustomSegments = async () => {
            const params = {
                limit: 10,
                offset: offset * 10,
                ordering: "-id",
                regulation__is_published: false,
                custom_link__selected_link: true,
                regulation__scenario__id: scenario.id,
                fields: "regulation__id,regulation__action,regulation__is_published,regulation__payment,regulation__proposed_restrictions,regulation__regulationId,regulation__actual_regulation_id,regulation__effective_dates_period,regulation__proposedregulationlinks_set__curb_link__bl_street_name,regulation__proposedregulationlinks_set__id,regulation__proposedregulationlinks_set__custom_link__bl_street_name,regulation__proposedregulationlinks_set__custom_link__id,regulation__proposedregulationlinks_set__id,regulation__proposedregulationlinks_set__curb_link__id,regulation__proposedregulationlinks_set__custom_link__parent_link,regulation__sub_activity__display_name,regulation__sub_activity__id,regulation__sub_activity__activity__name,regulation__description",
                ...(regIds.length ? { regulation__sub_activity__id__in: regIds } : {}),
                ...(selectedFees.length ? { fees__in: selectedFees } : {})
            };
            const url = makeUrl("/api/proposedregulationlinks/fetch_custom_segments/", params);
            return await axios.post(url, payload).then((response) => response.data);
        };

        const getExistingRegulations = async () => {
            const params = {
                limit: 10,
                offset: offset * 10,
                distinct_restrictions: true,
                ordering: "regulationlinks__segment_priority",
                fields: "id,is_published,payment,restriction_set,regulationId,actual_regulation_id,effective_dates_period,time_limit,regulationlinks_set__curb_link__bays_count,regulationlinks_set__curb_link__bl_street_name,regulationlinks_set__curb_link__id,sub_activity__display_name,sub_activity__activity__name,sub_activity__id,regulationlinks_set__custom_link__bl_street_name,regulationlinks_set__custom_link__id,sub_activity__is_general_restriction,description",
                ...(regIds.length ? { sub_activity__id__in: regIds } : {}),
                ...(selectedFees.length ? { fees__in: selectedFees } : {})
            };
            const url = makeUrl("/api/regulation/fetch_existing/", params);
            return await axios.post(url, payload).then((response) => response.data);
        };

        if (Object.keys(params).length === 0) {
            yield put(
                allProposedRegulationReceived({ allProposedRegulationReceived: {}, requestOrigin })
            );
            return;
        }

        let result: any = {};

        let totalProposedRegulation = 0;
        let proposedRegulationList: any[] = [];
        let totalExistingRegulation = 0;
        let existingRegulationsList: any[] = [];

        // FIXME: patch work around for single link deselection
        // TODO: default action for now, will reset the regulation after deselection of segment.
        // SINGLE_LINK_DESELECTED, CURBIQ-6246
        if (type === "all") {
            yield put(
                allProposedRegulationReceived({
                    allProposedRegulationReceived: {},
                    requestOrigin: null
                })
            );
        }

        if (type === "proposed" || type === "all") {
            const json = yield getProposedRegulation();
            const proposedCustomSegments = yield getProposedCustomSegments();

            proposedRegulationList = [...json.results];
            if (proposedCustomSegments.results.length > 0) {
                const formatted = proposedCustomSegments.results.map((item: any) => ({
                    ...item.regulation
                }));
                proposedRegulationList.push(...formatted);
            }

            if (offset > 0) {
                const prior = yield select(allProposedRegulationsReceived);
                result = {
                    ...prior,
                    unPublishedProposedRegulation: [
                        ...prior.unPublishedProposedRegulation,
                        ...proposedRegulationList
                    ]
                };
            } else {
                totalProposedRegulation = json.meta.count + proposedCustomSegments.meta.count;
            }
        }

        if (type === "existing" || type === "all") {
            const existingData = yield getExistingRegulations();
            existingRegulationsList = existingData.results;

            if (offset > 0) {
                const prior = yield select(allProposedRegulationsReceived);
                result = {
                    ...prior,
                    existingRegulations: [...prior.existingRegulations, ...existingRegulationsList]
                };
            } else {
                totalExistingRegulation = existingData.meta.count;
                result = {
                    existingRegulations: existingRegulationsList
                };
            }
        }

        if (type === "all" && offset === 0) {
            result = {
                unPublishedProposedRegulation: proposedRegulationList,
                existingRegulations: existingRegulationsList,
                totalProposedChanges: totalProposedRegulation,
                totalExistingRegulations: totalExistingRegulation
            };
        }

        yield put(
            allProposedRegulationReceived({ allProposedRegulationReceived: result, requestOrigin })
        );
    } catch (error) {
        yield put(
            allProposedRegulationReceived({
                allProposedRegulationReceived: {
                    existingRegulations: [],
                    unPublishedProposedRegulation: []
                },
                requestOrigin: action.payload.requestOrigin
            })
        );
        showError(error);
    }
}

export function* getAllProposedChangesSaga() {
    yield takeLatest(GET_ALL_PROPOSED_REGULATIONS_BY_ID, fetchAllProposedChangesById);
}
